export default __webpack_public_path__ + "static/media/VERTICE.76413bec.webp";